import React from 'react';
import './TopBar.scss';
import logoImg from 'assets/images/logo-full.png';

interface TopBarProps {
  [key: string]: any;
}

export const TopBar = (props: TopBarProps) => {
  const { } = props;
  return (
    <div className='top-bar'>
      <div className='icon-container' onClick={() => { window.location.href = "https://www.constlending.com"; }}>
        <img src={logoImg} alt="icon" width={178} />
      </div>
      <div className='right-container'>
        <div className="question">
          <span className="question-text">Text or call us at</span>
          <span className="phone-number">(203) 423-3534</span>
        </div>
      </div>
    </div>
  );
}
